import {
  EncounterDischargeReasonCode,
  encounterDischargeReasonCodeDisplay,
} from '@quromedical/fhir-common';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type React from 'react';
import { strings } from 'strings';
import { z } from 'zod';

const AdmissionDischargeReasonSchema = z.object({
  statusReason: z.nativeEnum(EncounterDischargeReasonCode),
  periodEnd: z.string(),
});
type AdmissionDischargeReason = z.infer<typeof AdmissionDischargeReasonSchema>;

export interface AdmissionDischargeReasonProps {
  onChange?: (data: AdmissionDischargeReason) => void;
}

const dischargeReasons: EncounterDischargeReasonCode[] = Object.values(
  EncounterDischargeReasonCode,
);

const mapEncounterDischargeReasons = (): {
  display: string;
  value: EncounterDischargeReasonCode;
}[] => {
  return dischargeReasons.map((reason) => ({
    display: encounterDischargeReasonCodeDisplay[reason],
    value: reason,
  }));
};

const createFields = (): Field<AdmissionDischargeReason>[] => {
  const lastMonthDate = new Date();
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  lastMonthDate.setDate(1);

  return [
    {
      subfields: [
        {
          key: 'periodEnd',
          type: 'date-component',
          label: strings.AdmissionDischargeLabel,
          maskType: 'date',
          validRange: { startDate: lastMonthDate },
        },
      ],
    },
    {
      subfields: [
        {
          key: 'statusReason',
          type: 'combobox-single',
          label: strings.AdmissionDischargeReasonLabel,
          fetcher: mapEncounterDischargeReasons(),
        },
      ],
    },
  ];
};

export const AdmissionDischargeReason: React.FC<
  AdmissionDischargeReasonProps
> = ({ onChange }) => {
  const fields = createFields();

  return (
    <CrudForm
      fields={fields}
      initialValues={{}}
      showSubmitButton={false}
      onChange={onChange}
      validationSchema={AdmissionDischargeReasonSchema}
      cardProps={{ unsetZIndex: true }}
      hasCard={false}
      onChangeDebounceTime={0}
    />
  );
};
